import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CardActionLinkText: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text
}) => (
    <span className={`${styles.cardActionLinkText} ${className}`} data-testid={testId}>
        {text}
    </span>
);

export default CardActionLinkText;
